import { useGetGuide, type GuideInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Flex, Grid, Spinner, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";
import { CustomDescription, CustomTitle } from "./guideDetail.style";

export const GuideDetail = () => {
    const { data } = useGetGuide<GuideInfoResponse>({ section: "guide" });

    const currentGuide = data?.currentGuide[0].contents
        .split("●")
        .map((item) => item.trim())
        .filter((item) => {
            const plainText = item.replace(/<[^>]*>/g, "").trim();
            return plainText.length > 0;
        })
        .map((item) => {
            // 첫 ㆍ 또는 <br> 기준으로 타이틀/본문 분리
            const splitIndex = item.search(/ㆍ|<br\s*\/?>/i);

            let title = item;
            let contentRaw = "";

            if (splitIndex !== -1) {
                title = item.slice(0, splitIndex);
                contentRaw = item.slice(splitIndex);
            }

            // 타이틀 clean
            const cleanTitle = `● ${title.replace(/<br\s*\/?>/gi, "").trim()}`;

            // 본문을 <br>로 나누어 배열화
            const content = contentRaw
                .split(/<br\s*\/?>/i)
                .map((line) => line.trim())
                .filter((line) => line.length > 0);

            return {
                title: cleanTitle,
                content, // 확실한 배열!
            };
        });

    const { isTablet, isMobile } = MEDIA();

    return data ? (
        <Center as="section" flexDir="column" rowGap={isTablet ? "32px" : "64px"}>
            <Center flexDir="column">
                <CustomTitle fontFamily="Cormorant">Pension Notice</CustomTitle>
                <Text fontFamily="Cormorant">예약 상세안내</Text>
            </Center>

            <Grid gridTemplateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(2, 1fr)"} gridGap="40px">
                {currentGuide &&
                    currentGuide.map((current) => {
                        return (
                            <Flex flexDir="column" rowGap="16px" key={`guide_${Math.random()}`}>
                                <CustomDescription.TITLE
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(current.title) }}
                                />
                                <Box>
                                    {current.content.map((it) => (
                                        <CustomDescription.SUB
                                            key={`des_${Math.random()}`}
                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(it) }}
                                        />
                                    ))}
                                </Box>
                            </Flex>
                        );
                    })}
            </Grid>
        </Center>
    ) : (
        <Spinner />
    );
};
